import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import {
  EntityHasSubcomponentsCard,
  EntityLinksCard,
  hasCatalogProcessingErrors,
} from '@backstage/plugin-catalog';
import { entityWarningContent } from './entityWarningContent';
import { EntityDomainPageAboutCard } from '@internal/plugin-domain-page-about-card';
import { LinguistCard } from '../../../pages/Linguist';
import { isBusinessComponent } from '../pages/ComponentPage';
import { LinearProgress } from '@mui/material';
import { useEntity } from '@backstage/plugin-catalog-react';
import { contentpages, notification } from '../../../utils/constants';
import GraphCard from '../../EntityCatalogGraphCard';

function createOverviewContent(isBusinessComponent: boolean,type:string) {
  const isComponent =
    window?.location?.pathname?.split('/')[3]?.toLowerCase() === 'component';
  const isContentPage = type.includes(contentpages);

  return (
    <Grid
      container
      spacing={3}
      alignItems="stretch"
      data-testid="entity-domain-page-about"
    >
      {entityWarningContent(hasCatalogProcessingErrors)}

      <Grid item md={6}>
        <EntityDomainPageAboutCard variant="gridItem" />
      </Grid>

      <Grid item md={6} xs={12}>
        {isComponent && !isBusinessComponent ? (
          <GraphCard isDefault height={400} />
        ) : (
          <Grid item md={12} xs={12}>
          {type===notification?.toLowerCase()?<GraphCard isDefault height={300}/>:<EntityLinksCard />}
          </Grid>
        )}
      </Grid>

      <Grid item md={12} xs={12}>
       {isComponent && !isContentPage ? <EntityLinksCard /> : null}
      </Grid>

      <Grid item md={12} xs={12}>
        {isComponent && !isBusinessComponent && (
          <EntityHasSubcomponentsCard />
        )}
      </Grid>

      <Grid item md={12}>
        {isComponent && !isBusinessComponent && <LinguistCard />}
      </Grid>
    </Grid>
  );
}

const OverviewContentLoader = () => {
  const [hasBusinessComponent, setHasBusinessComponent] = useState<boolean | null>(null);
  const {entity}=useEntity();
  useEffect(() => {
    async function fetchBusinessFlag() {
      try {
        const res = await isBusinessComponent()
        setHasBusinessComponent(res ?? false);
      } catch (err) {
        console.error('Error fetching business component flag:', err);
        setHasBusinessComponent(false);
      }
    }

    fetchBusinessFlag();
  }, []);

  // While loading, show a spinner
  if (hasBusinessComponent === null) {
    return <LinearProgress />;
  }

  return createOverviewContent(hasBusinessComponent,entity?.spec?.type?.toString()?.toLowerCase() as string);
};

export const overviewContent = <OverviewContentLoader />;
